export const BOOM_PUMP = 'PLACING_BOOM_PUMP';
export const STATIONARY_PUMP = 'STATIONARY_PUMP';
export const PUMP = 'PUMP';

export const BOOM_PUMP_CODE = '6';
export const STATIONARY_PUMP_CODE = '7';

export const isApiPumpType = (value: string) => {
  return [BOOM_PUMP, STATIONARY_PUMP].includes(value);
};
